import { render, staticRenderFns } from "./FireStoppingReportAdd.vue?vue&type=template&id=87619942&"
import script from "./FireStoppingReportAdd.vue?vue&type=script&lang=js&"
export * from "./FireStoppingReportAdd.vue?vue&type=script&lang=js&"
import style0 from "./FireStoppingReportAdd.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports